export default "__VITE_ASSET__Cbc4uJ0o__"